import { useTranslation } from 'react-i18next';

import { OkBtn } from 'assets/images';
import './style.scss';

const CustomImgButton = ({ title, img = OkBtn, className, onClose, disabled }) => {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t('customImgButton.defaultTitle');
  return (
    <div className={`custom-img-button ${className} ${disabled ? 'disabled' : ''}`} onClick={disabled ? undefined : onClose}>
      <img alt="icon" src={img} />
      <span>{resolvedTitle}</span>
    </div>
  );
};

export default CustomImgButton;
